import { View, ViewStyle } from "react-native"
import Svg, { Path, Circle } from "react-native-svg"
import { useTheme } from "styled-rn"

import { Theme } from "$consts/hostAPI"

/*
 * These icons don't use the IconProps interface but they probably should.
 */

export const CircleTick = (props: { style?: ViewStyle; tickColorKey?: keyof Theme; bgColorKey?: keyof Theme }) => {
  const theme = useTheme()
  return (
    <View style={props.style}>
      <Svg width="19" height="19" viewBox="0 0 20 20">
        <Circle cx="9.5" cy="9.5" r="9.5" fill={props.tickColorKey ? theme[props.tickColorKey] : theme.a_bg} />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 19C14.7467 20 20 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19ZM6.18944 8.64718C5.69962 8.15678 4.89421 8.14718 4.39124 8.62476C4.15126 8.85554 4.01321 9.16965 4.00006 9.50299C3.99677 9.82993 4.12493 10.1505 4.36163 10.3844L7.60303 13.6249C7.8463 13.8653 8.17835 14.0031 8.52681 13.9999C8.87528 13.9967 9.20395 13.8557 9.44393 13.6089L15.6572 7.08944C15.8873 6.84905 16.0122 6.52852 15.9991 6.19838C15.9892 5.86824 15.8413 5.55735 15.5947 5.33298C15.0786 4.86502 14.2731 4.89385 13.7964 5.39707L8.4972 10.9582L6.18944 8.64718Z"
          fill={props.bgColorKey ? theme[props.bgColorKey] : theme.a_puzmo}
        />
      </Svg>
    </View>
  )
}

export const Tick = (props: { fill?: keyof Theme; width: number; height: number; style?: ViewStyle }) => {
  const theme = useTheme()

  return (
    <Svg viewBox="0 0 15 12" width={props.width} height={props.height} style={props.style}>
      <Path
        d="M0.489053 4.83302C1.11777 4.19625 2.12452 4.20904 2.7368 4.86291L5.6215 7.94424L12.2455 0.52943C12.8414 -0.141532 13.8482 -0.179974 14.4934 0.443978C14.8016 0.743133 14.9865 1.15766 14.9988 1.59784C15.0153 2.03803 14.8591 2.4654 14.5714 2.78593L6.80491 11.4785C6.50494 11.8076 6.0941 11.9957 5.65852 11.9999C5.22294 12.0042 4.80788 11.8204 4.50379 11.4999L0.452034 7.17924C0.156168 6.86727 -0.00403211 6.4399 7.71327e-05 6.00399C0.0165141 5.55953 0.189078 5.14072 0.489053 4.83302Z"
        fill={theme[props.fill || "fg"]}
      />
    </Svg>
  )
}

export const StrokedTick = (props: { fill?: keyof Theme; stroke?: keyof Theme; width: number; strokeWidth?: number }) => {
  const theme = useTheme()

  return (
    <Svg viewBox="0 0 24 24" width={props.width} height={props.width} fill="red">
      <Path
        d="m4.924 5.008C5.1433 5.231 5.3627 5.454 5.724 5.792L6.4475 6.5569 10.9792 1.8167C11.1682 1.5899 11.3999 1.4029 11.6602 1.2653L11.6602 1.2653C11.936 1.1196 12.2387 1.0321 12.5491 1.0073 12.8594.9825 13.172 1.0209 13.4672 1.1204 13.7625 1.22 14.0351 1.379 14.2669 1.5889L14.2669 1.5889C14.4988 1.7988 14.685 2.055 14.8119 2.3423L14.8119 2.3423C14.9388 2.6297 15.0031 2.9408 14.9999 3.2554 14.9967 3.5701 14.926 3.8797 14.7933 4.1644 14.6682 4.4329 14.4909 4.6727 14.2731 4.8713L8.1317 11.3037 8.1263 11.3094 8.1263 11.3093C7.9152 11.527 7.6626 11.6993 7.3845 11.8174 7.1064 11.9355 6.8077 11.9973 6.5061 11.9999 6.2044 12.0025 5.9047 11.9458 5.6247 11.8325L5.6247 11.8325C5.3446 11.7192 5.0891 11.5513 4.8743 11.3375L4.8737 11.3369 1.6525 8.125C1.6525 8.1249 1.6524 8.1249 1.6524 8.1248 1.4429 7.916 1.2764 7.6674 1.164 7.3926 1.0515 7.1179.9956 6.8232 1.0003 6.5259S1.067 5.424 1.75 4.82c.721-.624 1.4617-.6271 2.1447-.4761C4.562 4.568 4.659 4.763 4.924 5.008"
        fill={theme[props.fill || "fg"]}
        stroke={theme[props.stroke || "a_bg"]}
        strokeWidth={props.strokeWidth || 2}
      />
    </Svg>
  )
}
